export default __webpack_public_path__ + "static/char-s-sp02-kr-4eca53c2359804b4bd920f72877bf701.png";